import {PreviewForm} from "./components/preview-form"
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="">
      <PreviewForm />
    </div>
  );
}

export default App;
